export default function multiGuard(guards) {
    return (to, from, next) => {
        const stack = [].concat(guards)
        function another(param) {
            if (param) {
                next(param)
            } else {
                const guard = stack.shift()
                if (guard) {
                    guard(to, from, another)
                } else {
                    next()
                }
            }
        }
        another()
    }
}
